import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';

@Component({
    selector: 'app-admin-panel',
    templateUrl: './admin-panel.component.html',
    styleUrls: ['./admin-panel.component.scss']
})
export class AdminPanelComponent implements OnInit {

    constructor(
        public router: Router,
        protected appStateQuery: AppStateQuery
    ) {
    }

    ngOnInit(): void {

    }
}